import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Pro = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M13.8722 10.7778C13.5466 10.7778 13.3079 10.4715 13.3874 10.1557L14.9531 3.93625C15.1537 3.13966 14.1671 2.59436 13.5992 3.18793L5.29435 11.8692C4.80755 12.3781 5.16822 13.2222 5.87243 13.2222H10.1278C10.4534 13.2222 10.6921 13.5285 10.6126 13.8443L9.04689 20.0638C8.84635 20.8603 9.83292 21.4056 10.4008 20.8121L18.7056 12.1308C19.1924 11.6219 18.8318 10.7778 18.1276 10.7778L13.8722 10.7778Z'
        stroke='currentColor'
        strokeWidth='1.5'
      />
    ) : (
      <path
        d='M13.8722 10.7778C13.5466 10.7778 13.3079 10.4715 13.3874 10.1557L14.9531 3.93625C15.1537 3.13966 14.1671 2.59436 13.5992 3.18793L5.29435 11.8692C4.80755 12.3781 5.16822 13.2222 5.87243 13.2222H10.1278C10.4534 13.2222 10.6921 13.5285 10.6126 13.8443L9.04689 20.0638C8.84635 20.8603 9.83292 21.4056 10.4008 20.8121L18.7056 12.1308C19.1924 11.6219 18.8318 10.7778 18.1276 10.7778L13.8722 10.7778Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
